import React, { useState } from 'react';
import { FaEnvelope, FaMapMarkerAlt, FaUpload, FaPaperPlane } from 'react-icons/fa';

const QuoteRequestForm = ({ onClose }) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    company: '',
    phone: '',
    email: '',
    address: '',
    city: '',
    postalCode: '',
    materials: [],
    operations: [],
    experience: '',
    message: '',
    files: null,
  });

  const materials = [
    { id: 'acier', label: 'Acier' },
    { id: 'inox', label: 'Inox' },
    { id: "alliages-aluminium", label: "Alliages d'aluminium" },
    { id: 'cuivre', label: 'Cuivre' },
    { id: 'laiton', label: 'Laiton' },
    { id: 'autre', label: 'Autre' },
  ];

  const operations = [
    { id: 'pliage', label: 'Pliage' },
    { id: 'soudage', label: 'Soudage' },
    { id: 'peinture', label: 'Peinture' },
    { id: 'autre-operation', label: 'Autre' },
  ];

  const toggleInArray = (key, value, checked) => {
    setFormData(prev => ({
      ...prev,
      [key]: checked ? [...prev[key], value] : prev[key].filter(id => id !== value)
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // For now just log; integrate backend later
    // eslint-disable-next-line no-console
    console.log('Quote form submitted:', formData);
    alert('Votre demande de devis a été envoyée.');
  };

  return (
    <section id="devis" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto rounded-2xl border border-gray-200 bg-white shadow-sm">
          <div className="text-center px-6 pt-8 pb-4">
            <h2 className="text-2xl font-bold text-gray-900">Demande de devis</h2>
            <p className="text-gray-600 mt-1">Remplissez ce formulaire pour recevoir votre devis personnalisé</p>
          </div>

          <div className="px-6 pb-8">
            <form onSubmit={handleSubmit} className="space-y-10">
              {/* Coordonnées */}
              <div className="space-y-6">
                <div className="flex items-center gap-2">
                  <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 text-gray-700"><FaEnvelope /></span>
                  <h3 className="text-lg font-semibold text-gray-900">Vos coordonnées</h3>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <label htmlFor="firstName" className="text-sm text-gray-700">Prénom *</label>
                    <input id="firstName" value={formData.firstName} onChange={(e)=>setFormData(prev=>({...prev, firstName:e.target.value}))} required className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-900" />
                  </div>
                  <div className="space-y-2">
                    <label htmlFor="lastName" className="text-sm text-gray-700">Nom *</label>
                    <input id="lastName" value={formData.lastName} onChange={(e)=>setFormData(prev=>({...prev, lastName:e.target.value}))} required className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-900" />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <label htmlFor="company" className="text-sm text-gray-700">Société</label>
                    <input id="company" value={formData.company} onChange={(e)=>setFormData(prev=>({...prev, company:e.target.value}))} className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-900" />
                  </div>
                  <div className="space-y-2">
                    <label htmlFor="phone" className="text-sm text-gray-700">Téléphone *</label>
                    <input id="phone" type="tel" value={formData.phone} onChange={(e)=>setFormData(prev=>({...prev, phone:e.target.value}))} required className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-900" />
                  </div>
                </div>

                <div className="space-y-2">
                  <label htmlFor="email" className="text-sm text-gray-700">E-mail *</label>
                  <input id="email" type="email" value={formData.email} onChange={(e)=>setFormData(prev=>({...prev, email:e.target.value}))} required className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-900" />
                </div>

                <div className="space-y-2">
                  <label htmlFor="address" className="text-sm text-gray-700">Adresse *</label>
                  <input id="address" value={formData.address} onChange={(e)=>setFormData(prev=>({...prev, address:e.target.value}))} required className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-900" />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <label htmlFor="city" className="text-sm text-gray-700">Ville</label>
                    <input id="city" value={formData.city} onChange={(e)=>setFormData(prev=>({...prev, city:e.target.value}))} className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-900" />
                  </div>
                  <div className="space-y-2">
                    <label htmlFor="postalCode" className="text-sm text-gray-700">Code postal</label>
                    <input id="postalCode" value={formData.postalCode} onChange={(e)=>setFormData(prev=>({...prev, postalCode:e.target.value}))} className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-900" />
                  </div>
                </div>
              </div>

              {/* Demande */}
              <div className="space-y-6">
                <div className="flex items-center gap-2">
                  <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 text-gray-700"><FaMapMarkerAlt /></span>
                  <h3 className="text-lg font-semibold text-gray-900">Votre demande</h3>
                </div>

                <div className="space-y-4">
                  <div>
                    <label className="text-sm font-medium text-gray-800 mb-2 block">Indiquez la matière choisie</label>
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                      {materials.map(m => (
                        <label key={m.id} className="flex items-center gap-2 text-sm text-gray-800">
                          <input type="checkbox" checked={formData.materials.includes(m.id)} onChange={(e)=>toggleInArray('materials', m.id, e.target.checked)} className="h-4 w-4 rounded border-gray-400 text-gray-900 focus:ring-gray-900" />
                          {m.label}
                        </label>
                      ))}
                    </div>
                  </div>

                  <div>
                    <label className="text-sm font-medium text-gray-800 mb-2 block">Opérations complémentaires</label>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                      {operations.map(op => (
                        <label key={op.id} className="flex items-center gap-2 text-sm text-gray-800">
                          <input type="checkbox" checked={formData.operations.includes(op.id)} onChange={(e)=>toggleInArray('operations', op.id, e.target.checked)} className="h-4 w-4 rounded border-gray-400 text-gray-900 focus:ring-gray-900" />
                          {op.label}
                        </label>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="space-y-2">
                  <label htmlFor="experience" className="text-sm text-gray-700">Avez-vous une expérience de débit ?</label>
                  <textarea id="experience" value={formData.experience} onChange={(e)=>setFormData(prev=>({...prev, experience:e.target.value}))} placeholder="Décrivez votre expérience..." className="w-full rounded-md border border-gray-300 px-3 py-2 min-h-[100px] focus:outline-none focus:ring-2 focus:ring-gray-900" />
                </div>

                <div className="space-y-2">
                  <label htmlFor="message" className="text-sm text-gray-700">Votre message</label>
                  <textarea id="message" value={formData.message} onChange={(e)=>setFormData(prev=>({...prev, message:e.target.value}))} placeholder="Décrivez votre projet en détail..." className="w-full rounded-md border border-gray-300 px-3 py-2 min-h-[120px] focus:outline-none focus:ring-2 focus:ring-gray-900" />
                </div>
              </div>

              {/* Fichiers */}
              <div className="space-y-4">
                <div className="flex items-center gap-2">
                  <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 text-gray-700"><FaUpload /></span>
                  <h3 className="text-lg font-semibold text-gray-900">Joindre vos fichiers</h3>
                </div>
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-gray-500 transition-colors">
                  <FaUpload className="w-8 h-8 text-gray-400 mx-auto mb-2" />
                  <label htmlFor="files" className="cursor-pointer">
                    <span className="text-gray-900 font-medium">Cliquez pour sélectionner des fichiers</span>
                    <span className="text-gray-500"> ou glissez-déposez</span>
                  </label>
                  <input id="files" type="file" multiple onChange={(e)=>setFormData(prev=>({...prev, files:e.target.files}))} className="hidden" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.dwg" />
                  <p className="text-xs text-gray-500 mt-2">Formats: PDF, DOC, JPG, PNG, DWG (max. 10MB)</p>
                </div>
              </div>

              {/* Submit */}
              <div className="pt-2">
                <button type="submit" className="w-full inline-flex items-center justify-center gap-2 rounded-md bg-gray-900 text-white px-5 py-3 font-semibold hover:bg-black transition-colors">
                  <FaPaperPlane />
                  Envoyer ma demande de devis
                </button>
              </div>
              <p className="text-center text-sm text-gray-500">Vos données sont protégées et ne seront utilisées que pour traiter votre demande.</p>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuoteRequestForm;


